// src/utils/languageUtils.ts

// Interface for language information
export interface Language {
    code: string;
    name: string;
    nativeName?: string;
  }
  
  // List of supported languages for voice recognition
  // Based on common languages supported by speech-to-text APIs
  export const supportedLanguages: Language[] = [
    { code: 'en-US', name: 'English (US)' },
    { code: 'en-GB', name: 'English (UK)' },
    { code: 'cs-CZ', name: 'Česky' },
    { code: 'sk-SK', name: 'Slovensky' }
  ];
  
  // Get user's browser language and find closest match in supported languages
  export function getPreferredLanguage(): string {
    const browserLang = navigator.language || 'en-US';
    
    // Try to find exact match
    const exactMatch = supportedLanguages.find(lang => lang.code === browserLang);
    if (exactMatch) return exactMatch.code;
    
    // Try to find match with same primary language
    const primaryLang = browserLang.split('-')[0];
    const partialMatch = supportedLanguages.find(lang => lang.code.startsWith(primaryLang + '-'));
    if (partialMatch) return partialMatch.code;
    
    // Default to English
    return 'en-US';
  }
  
  // Get language display name from code
  export function getLanguageDisplayName(code: string): string {
    const language = supportedLanguages.find(lang => lang.code === code);
    return language ? language.name : code;
  }